import script from "./PhotoCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoCarousel.vue?vue&type=script&setup=true&lang=js"

import "./PhotoCarousel.vue?vue&type=style&index=0&id=46f421f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f421f0"]])

export default __exports__